import { Form, Radio, Space } from "antd";
import React from "react";

export default function RadioField(props) {

    const { data = {}, contact = {}, label_class = "", label_help_class = "", label_description_class = "" } = props;

    const {
        id = "",
        label = "Select",
        type = "select",
        description = "",
        options = [],
        required = false,
        required_message = "This field is required",
    } = data;

    let defaultValue = (contact.hasOwnProperty([id])) ? contact[id] : options[0].label;

    return (

        <div>
            <Form.Item
                rules={[{ required: required, message: (required_message) ? <div className={label_help_class}>{required_message}</div> : <div className={label_help_class}>This field is required</div> }]}
                label={
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <span className={label_class + " " + "inlineforce"} style={{ lineHeight: '1' }}>{label}</span>
                        <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}><span className={label_description_class}>{description}</span></div>
                    </div>
                }
                name={id}
            >
                <Radio.Group>
                    {options.map(item => (
                        <Radio style={{ display: 'block' }} value={item.label}>
                            <span className={label_class + " " + "inlineforce"}>{item.label}</span>
                        </Radio>
                    ))}
                </Radio.Group>
            </Form.Item>
        </div>
    )
}